import * as React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  trialRemaining: {
    color: "green",
    "&.red": {
      color: "red",
    },
    "&.orange": {
      color: "orange",
    },
  },
});

const TrialRemaining = ({ user, classes }) => {
  const thresholds = [
    { days: 3, color: "red" },
    { days: 5, color: "orange" },
  ];

  const currentThreshold = thresholds.find(
    (t) => t.days >= user.trialRemaining
  );
  const color = (currentThreshold && currentThreshold.color) || "";

  let text;
  if (user.trialRemaining < 0) {
    text = user.totalOnboarded > 0 ? "" : "expired";
  } else {
    text =
      user.trialRemaining > 1
        ? `${user.trialRemaining} days`
        : `${user.trialRemaining} day`;
  }

  return (
    <Typography className={`${classes.trialRemaining} ${color}`}>
      {text}
    </Typography>
  );
};

export default withStyles(styles)(TrialRemaining);



// WEBPACK FOOTER //
// ./src/components/UI/TrialRemaining.jsx